import { render, staticRenderFns } from "./ArticlesBox.vue?vue&type=template&id=72402f97&"
import script from "./ArticlesBox.vue?vue&type=script&lang=js&"
export * from "./ArticlesBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports